import { Skeleton } from "antd";
import type { IEmployee } from "../../../../app/features/employee/employee.types";
import Section from "../_icons/Section";
import Info from "./Info";

type Props = {
  data?: IEmployee;
  loading?: boolean;
};

export default function EducationInfo({ data, loading }: Props) {
  if (loading) {
    return (
      <Section title="শিক্ষাগত যোগ্যতা" type="education">
        <Skeleton active paragraph={{ rows: 2 }} />
      </Section>
    );
  }

  return (
    <Section title="শিক্ষাগত যোগ্যতা" type="education">
      {data?.education?.length ? (
        data.education.map((edu, index) => (
          <Info
            key={index}
            label="যোগ্যতা"
            value={`${edu.level} - ${edu.institute || "N/A"}`}
            // img={edu.certificateUrl} // TODO: Handle certificate image if needed
          />
        ))
      ) : (
        <div className="text-sm text-gray-500">কোন তথ্য নেই</div>
      )}
    </Section>
  );
}
